export const contactData = {
  email: "kontakt@studioklara.pl",
};
